import { Outlet } from 'react-router-dom';
import { Logo } from '../atoms';
import React from 'react';
import styled, { css } from 'styled-components';
import backgroundImg from '../../components/images/login-background.jpg';

const PageLayout = styled.div`
  display: flex;
  min-height: 100vh;
`;

const Sidebar = styled.div(
  ({ theme }) => css`
    position: sticky;
    top: 0;
    flex: 0 0 450px;
    max-width: 450px;
    box-shadow: ${theme.colors.main.boxShadow};

    @media (max-width: ${theme.breakpoints.max.sm}) {
      flex: 0 0 28%;
      max-width: 28%;
    }
  `
);

const SidebarContent = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const OutletContainer = styled.div`
  padding: 30px;
`;

const LogoContainer = styled.div(
  ({ theme }) => css`
    padding: 7px 30px;
    background-color: ${theme.colors.main.primary};

    @media (max-width: ${theme.breakpoints.max.md}) {
      padding: 7px 15px;
    }
  `
);

const Image = styled.div`
  width: 100%;
  background-image: url(${backgroundImg});
  background-size: cover;
  background-position: center;
`;

const LoginTemplate = () => {
  return (
    <PageLayout>
      <Sidebar>
        <SidebarContent>
          <LogoContainer>
            <Logo />
          </LogoContainer>
          <OutletContainer>
            <Outlet />
          </OutletContainer>
        </SidebarContent>
      </Sidebar>
      <Image />
    </PageLayout>
  );
};

export { LoginTemplate };
